import React, { useState } from 'react';
import './Leaderboard.css';

const Leaderboard = ({ records, onPersonSelect }) => {
  // Calculate total score for a record
  const calculateScore = (record) => {
    return (
      (record.alcohol || 0) +
      (record.eating || 0) +
      (record.hydration || 0) +
      (record.running || 0) +
      (record.supplements || 0) +
      (record.meditation || 0) +
      (record.walking || 0) +
      (record.workingOut || 0) +
      (record.bonus || 0)
    );
  };

  // Process records to get scores by person
  const processRecords = (records) => {
    const scoresByPerson = {};
    const entriesByPerson = {};  // Tracks number of entries per person
    
    // Convert records object to array of all records
    const recordsArray = Object.values(records).flat();
    
    recordsArray.forEach(record => {
      if (!record.name) return;  // Skip records without names
      
      const score = calculateScore(record);
      const name = record.name;
      
      // Only count if there's an actual score
      if (score > 0) {
        // Initialize if first entry
        if (!scoresByPerson[name]) {
          scoresByPerson[name] = score;
          entriesByPerson[name] = 1;
        } else {
          scoresByPerson[name] += score;
          entriesByPerson[name] += 1;
        }
      }
    });

    // Add console.log to debug
    //console.log('Entries by person:', entriesByPerson);

    return Object.entries(scoresByPerson)
      .map(([name, score]) => ({ 
        name, 
        score,
        numEntries: entriesByPerson[name]
      }))
      .sort((a, b) => b.score - a.score);
  };

  const allTimeScores = processRecords(records);
  //console.log(JSON.stringify(allTimeScores));

  return (
    <div className="leaderboard">
      <div className="section">
        {allTimeScores.length === 0 ? (
          <div className="no-records-message">
            No one has added any records yet.<br></br>Be the first!
          </div>
        ) : (
          <>
            <div className="table-header">
              <h1></h1>
              <div className="right-header">
                <h1># Entries</h1>
                <h1>Avg</h1>
                <h1>Total</h1>
              </div>
            </div>
            <div className="scores-list">
              {allTimeScores.map((player, index) => (
                <div 
                  key={player.name} 
                  className="score-item"
                  onClick={() => onPersonSelect(player.name)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="rank">{index + 1}</span>
                  <span className="name">{player.name}</span>
                  <span className="entries">{player.numEntries}</span>
                  <span className="avg">{Math.round(player.score / player.numEntries)}</span>
                  <span className="score">{player.score}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
